import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { SectionReveal } from '../SectionReveal';
import { TOMOS } from '../../data/content';
export function Tomos() {
  return <section className="w-full bg-carbon-2" aria-labelledby="tomos-heading" data-id="element-184">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" data-id="element-185">
        <SectionReveal className="mb-12 text-center" data-id="element-186">
          <div className="mx-auto mb-6 h-px w-24 bg-gold" aria-hidden="true" data-id="element-187" />
          <h2 id="tomos-heading" className="font-heading text-2xl font-bold uppercase tracking-tight text-soft sm:text-4xl" data-id="element-188">
            📦 Lo que recibís: <span className="text-orange" data-id="element-189">6 Tomos</span>{' '}
            completos
          </h2>
          <div className="mx-auto mt-6 h-px w-24 bg-gold" aria-hidden="true" data-id="element-190" />
        </SectionReveal>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2" data-id="element-191">
          {TOMOS.map((tomo, i) => <SectionReveal key={tomo.number} delay={i % 2 * 0.08} className="relative overflow-hidden rounded-lg border-b border-gold-tenue bg-carbon-3 p-6 sm:p-8" data-id="element-192">
              <span className="pointer-events-none absolute -right-2 -top-6 font-display text-8xl font-extrabold text-orange/15 sm:text-9xl" aria-hidden="true" data-id="element-193">
                {tomo.number}
              </span>
              <div className="relative" data-id="element-194">
                <p className="font-heading text-xs font-bold uppercase tracking-widest text-orange" data-id="element-195">
                  {tomo.accentEmoji} Tomo {tomo.number}
                </p>
                <h3 className="mt-2 font-heading text-xl font-bold text-soft sm:text-2xl" data-id="element-196">
                  {tomo.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-197">
                  {tomo.subtitle}
                </p>
                <p className="mt-4 flex items-start gap-2 rounded-md bg-emerald/10 p-3 text-sm font-medium text-emerald" data-id="element-198">
                  <CheckCircle2Icon className="mt-0.5 h-4 w-4 flex-none" data-id="element-199" />
                  <span data-id="element-200">
                    <span className="font-bold" data-id="element-201">Resultado:</span> {tomo.result}
                  </span>
                </p>
              </div>
            </SectionReveal>)}
        </div>
      </div>
    </section>;
}